import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SVGComponent from '../../SVG/SVGComponent';
import {
  SVG_ICONS, PAGES, ROLE_STATUS,
} from '../../../constants';
import validateFields from '../../../utils/validation';

export default class UserModal extends Component {
  constructor(props) {
    super(props);

    /**
     * @member {object}
     * @property {string} username
     * @property {string} email
     * @property {string} name
     * @property {Array} roles
     * @property {object} errorMgs
     */
    this.state = {
      username: this.props.editInfo ? this.props.user.username : '',
      email: this.props.editInfo ? this.props.user.email : '',
      name: this.props.editInfo ? this.props.user.name : '',
      roles: props.editRoles
        ? props.user.roles.map((el) => el.id)
        : [''],
      errorMgs: {},

      dropdownOpen: null,
    };
  }

  componentDidMount() {
    if (this.props.editRoles || this.props.add) {
      this.props.getRoles({ skipParams: true });
    }
  }

  /**
   * Toggle dropdown
   *
   * @param {number} ind
   * @function
   * @returns {void}
   */
  toggleDropdown = (ind) => {
    if (this.state.dropdownOpen === ind) {
      this.setState({
        dropdownOpen: null,
      });
    } else {
      this.setState({
        dropdownOpen: ind,
      });
    }
  };

  /**
   * Updating state fields
   *
   * @function
   * @param {string} field
   * @param {Event} e
   * @returns {void}
   */
  updateField = (field, e) => {
    const value = e.target.value;
    const change = {};
    change[field] = value;
    this.setState(change);
  };

  /**
   * Handle select
   *
   * @function
   * @param {number} order
   * @param {Event} e
   * @returns {void}
   */
  handleSelect = (order, e) => {
    const value = parseInt(e.target.id);
    const newRoles = this.state.roles.slice(0);
    newRoles[order] = value;
    this.setState({
      roles: newRoles,
      errorMgs: {},
      dropdownOpen: null,
    });
  };

  /**
   * Handle add role
   *
   * @function
   * @returns {void}
   */
  handleAddRole = () => {
    const newRoles = this.state.roles.slice(0);
    newRoles.push('');
    this.setState({
      roles: newRoles,
      errorMgs: {},
    });
  };

  /**
   * Handle remove role
   *
   * @function
   * @param {numer} ind
   * @returns {void}
   */
  handleRemoveRole = (ind) => {
    const newRoles = this.state.roles.slice(0);
    newRoles.splice(ind, 1);
    this.setState({
      roles: newRoles,
      errorMgs: {},
    });
  };

  /**
   * Handle click on save
   *
   * @function
   * @returns {void}
   */
  handleSave = () => {
    const validationParams = [];
    if (!this.props.editInfo) {
      validationParams.push(
        {
          label: 'Role',
          fieldName: 'role',
          value: this.state.roles.toString().replace(/,/g, ''),
          rules: ['mandatory'],
        },
      );
    }
    if (this.props.add || this.props.editInfo) {
      if (this.props.add) {
        validationParams.push(
          {
            label: 'Username',
            fieldName: 'username',
            value: this.state.username.trim(),
            rules: ['mandatory'],
          },
        );
      }
      validationParams.push(
        {
          label: 'Name',
          fieldName: 'name',
          value: this.state.name.trim(),
          rules: ['mandatory'],
        },
      );
      validationParams.push(
        {
          label: 'Email',
          fieldName: 'email',
          value: this.state.email,
          rules: ['mandatory', 'regExp'],
          expression: '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$',
        },
      );
    }
    validateFields(validationParams)
      .then(() => {
        const body = {
          roleIds: this.state.roles.filter((x) => x !== ''),
          username: this.state.username,
          name: this.state.name,
          email: this.state.email,
          user: this.props.user,
        };
        this.props.save(body);
      }).catch((errorMgs) => {
        this.setState({ errorMgs });
      });
  };

  /**
   * Close modal
   *
   * @returns {void}
   */
  cancel = () => {
    this.props.setOpenModal({ modal: '' });
  };

  filterDropdownRoles = (roles) => roles.filter((role) => !this.state.roles.includes(role.roleId));

  /**
   * Render dropdown
   *
   * @function
   * @param {number} ind
   * @returns {view}
   */
  renderDropdown = (ind) => {
    const filteredRoles = this.filterDropdownRoles(this.props.roles);
    return filteredRoles.map((el) => (
      <div
        key={`role-opt-${ind}-${el.roleId}`}
        className="dialog__input-list-item"
        id={el.roleId}
        onClick={this.handleSelect.bind(this, ind)}
      >
        {el.name}
        {el.status === ROLE_STATUS.DISABLED && (
          <span className="option-disable">
            (
            {ROLE_STATUS[ROLE_STATUS.DISABLED]}
            )
          </span>
        )}
      </div>
    ));
  };

  /**
   * Get role name
   *
   * @function
   * @param {number} roleId
   * @returns {string} roleName
   */
  getRoleName = (roleId) => {
    const roleElement = this.props.roles.find((el) => el.roleId === roleId);
    return roleElement.name;
  };

  disabledCheck = (ind) => {
    const currentRole = this.props.roles.find((role) => role.roleId === this.state.roles[ind]);
    if (currentRole.status === ROLE_STATUS.DISABLED) {
      return (
        <span className="option-disable">
          {' '}
          (
          {ROLE_STATUS[ROLE_STATUS.DISABLED]}
          )

        </span>
      );
    }
    return null;
  };

  /**
   * Render role
   *
   * @function
   * @param {numer} ind
   * @param {boolean} showDelete
   * @returns {view}
   */
  renderRole = (ind, showDelete) => (
    <div className="dialog__row" key={`role-${ind}`}>
      <div className="dialog__input-wrap">
        <label className={`dialog__input-label ${showDelete ? 'dialog__input-label--cut' : ''}`}>Role</label>
        <div id="select_UserModal" className={`dialog__input dialog__input--select ${this.state.dropdownOpen === ind ? 'open' : ''}`} onClick={this.toggleDropdown.bind(this, ind)}>
          {this.state.roles[ind]
            ? (
              <span>
                {this.props.roles.length > 0 && this.getRoleName(this.state.roles[ind])}
                {' '}
                {this.props.roles.length > 0 && this.disabledCheck(ind)}
              </span>
            )
            : <span>Select Role</span>}
        </div>

        <div className="dialog__input-dropdown">
          <div className="dialog__input-list" id="dropdownList_UserModal">

            {this.renderDropdown(ind)}
          </div>
          <Link
            to={PAGES.ADMIN_ROLES_VIEW}
            className="dialog__input-dropdown-btn"
          >
            Manage Roles
          </Link>
        </div>

        {this.state.errorMgs.role}
      </div>
      {showDelete
        && (
          <div className="dialog__delete-icon" id="delete_UserModal">
            <SVGComponent
              onClick={this.handleRemoveRole.bind(this, ind)}
              className="icon-xs"
              src={`${SVG_ICONS.utility}#bin`}
            />
          </div>
        )}

    </div>
  );

  /**
   * Render user info inputs for add user modal
   *
   * @function
   * @returns {view}
   */
  renderUserInfo = () => (
    <>
      {!this.props.editInfo
        && (
          <div className="dialog__row">
            <div className="dialog__input-wrap">
              <label className="dialog__input-label">Username</label>
              {this.props.editInfo
                ? <div className="dialog__detail">{this.state.username}</div>
                : (
                  <input
                    id="username_UserModal"
                    type="text"
                    className="dialog__input"
                    value={this.state.username}
                    onChange={this.updateField.bind(this, 'username')}
                  />
                )}
              {this.state.errorMgs.username}
            </div>
          </div>
        )}
      <div className="dialog__row m-t-10">
        <div className="dialog__input-wrap">
          <label className="dialog__input-label">Name</label>
          <input
            id="name_UserModal"
            type="text"
            className="dialog__input"
            value={this.state.name}
            onChange={this.updateField.bind(this, 'name')}
          />
          {this.state.errorMgs.name}
        </div>
      </div>
      <div className="dialog__row m-t-10">
        <div className="dialog__input-wrap">
          <label className="dialog__input-label">Email</label>
          <input
            id="email_UserModal"
            type="email"
            className="dialog__input"
            value={this.state.email}
            onChange={this.updateField.bind(this, 'email')}
          />
          {this.state.errorMgs.email}
        </div>
      </div>

      {!this.props.editInfo && this.renderRole(0, false)}
    </>
  );

  /**
   * Render user info for edit user modal
   *
   * @function
   * @returns {view}
   */
  renderEditUserInfo = () => (
    <div className="dialog__panel m-b-20">
      <div className="dialog_panel-left">
        <div className="dialog__panel-title">Username</div>
        <div className="dialog__panel-name">{this.props.user.username}</div>
      </div>
      <div className="dialog__panel-right">
        <div className="dialog__panel-title">Email</div>
        <div className="dialog__panel-email">{this.props.user.email}</div>
      </div>
    </div>
  );

  /**
   * Render edit user modal
   *
   * @function
   * @returns {view}
   */
  // eslint-disable-next-line react/no-unused-class-component-methods
  renderEditUserModal = () => (
    <>
      <div className="dialog__row">
        <div className="dialog__fields">
          <label className="style-2">Username</label>
          <input
            id="username_EditUserModal"
            type="text"
            className="form-control"
            value={this.state.username}
            readOnly
          />
          {this.state.errorMgs.username}
        </div>
      </div>
      <div className="dialog__row">
        <div className="dialog__fields">
          <label className="style-2">Name</label>
          <input
            id="name_EditUserModal"
            type="text"
            className="form-control"
            value={this.state.name}
            onChange={this.updateField.bind(this, 'name')}
          />
          {this.state.errorMgs.name}
        </div>
      </div>
      <div className="dialog__row">
        <div className="dialog__fields">
          <label className="style-2">Email</label>
          <input
            id="email_EditUserModal"
            type="email"
            className="form-control"
            value={this.state.email}
            onChange={this.updateField.bind(this, 'email')}
          />
          {this.state.errorMgs.email}
        </div>
      </div>
    </>
  );

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <div className={`dialog open ${this.props.editRoles && 'drm'}`} id="add-user">
        <div className="dialog__heading">
          <span className="dialog__title">{this.props.heading}</span>
          <SVGComponent
            onClick={this.cancel}
            className="icon-xxs dialog__close"
            src={`${SVG_ICONS.utility}#close`}
          />
        </div>

        <div className="dialog__content">

          {this.props.editRoles && (
            this.renderEditUserInfo()
          )}
          <div className="dialog__role-wrap">
            {!this.props.editRoles && (
              this.renderUserInfo()
            )}

            {!this.props.editInfo
              && this.state.roles.map((el, ind) => {
                // skip first
                if (ind === 0 && this.props.add) return null;
                return this.renderRole(ind, this.props.add || this.state.roles.length > 1);
              })}
          </div>

          {!this.props.editInfo && (
            <div className="dialog__add-btn m-t-20" onClick={this.handleAddRole} id="addAnotherRole_UserModal">
              <span>+</span>
              Add another role
            </div>
          )}
        </div>

        <div className="dialog__btn-wrap">
          <button
            id="cancel_UserModal"
            type="button"
            className="btn btn-secondary"
            onClick={this.cancel}
          >
            Cancel
          </button>
          <button
            id="save_UserModal"
            type="button"
            className="btn btn-primary m-l-10"
            onClick={this.handleSave}
          >
            Save
          </button>
        </div>

      </div>
    );
  }
}
